import {ComponentPublicInstance} from "vue";

interface MyComponent extends ComponentPublicInstance {
    errors: {
        [key: string]: string[];
    };

    // eslint-disable-next-line no-unused-vars
    hasError: (name: string) => boolean;
}

export const validationMethods = () => {
    return {
        hasError(this: MyComponent, name: string): any {
            return this.errors[name] !== undefined;
        },

        getError(this: MyComponent, name: string): any {
            if (this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    };
};